// Autogenerated by publish_packages.clj
const version = 'v0.20.9';

export default version;
